import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initAnalyticsSession, trackPageView, closeAnalytics } from '../analytics/tracker';
import { initPresence, trackUniqueVisitor } from '../services/presenceService';

export const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Initialize privacy-safe analytics session (visitor/session ids, heartbeat).
    initAnalyticsSession();
    // Track unique visitor once per browser life (existing RTDB counter).
    trackUniqueVisitor();

    return () => {
      closeAnalytics();
    };
  }, []);

  useEffect(() => {
    const path = location.pathname;

    // Real-time analytics event for the admin dashboard / page analytics.
    trackPageView(path);

    // Legacy real-time presence (RTDB) — kept for the live "active now" widget.
    initPresence(path);
  }, [location.pathname]);
};